import React, { createContext, ReactNode, useContext } from 'react';

function noop() {
  return null;
}

interface LocationDescriptorObject {
  pathname?: string;
  search?: string;
  state?: unknown;
  hash?: string;
  key?: string;
}

interface Location {
  pathname: string;
  search: string;
  state: unknown;
  hash: string;
  key?: string;
}

export type UdsLinkElement = (props: {
  to: string | LocationDescriptorObject | ((location: Location) => string | LocationDescriptorObject);
  style?: React.CSSProperties;
  children?: React.ReactNode;
}) => ReactNode;

export interface UdsRoutingProviderProps {
  navigate: (path: string, options?: { state?: unknown; replace?: boolean }) => void;
  getLocation: () => {
    search: string;
    pathname: string;
    state: unknown;
  };
  matchPath: <Params extends { [K in keyof Params]?: string } = {}>(options: {
    path?: string;
    exact?: boolean;
  }) => boolean | null;
  NavLink: UdsLinkElement;
  Link: UdsLinkElement;
}

const UdsRoutingContext = createContext<UdsRoutingProviderProps>({
  Link: noop,
  NavLink: noop,
  navigate: noop,
  getLocation: () => ({
    pathname: '',
    search: '',
    state: undefined
  }),
  matchPath: noop
});

export const UdsRoutingProvider = ({ children, ...value }: UdsRoutingProviderProps & { children: React.ReactNode }) => {
  return <UdsRoutingContext.Provider value={value}>{children}</UdsRoutingContext.Provider>;
};

export const useUdsRouting = () => {
  return useContext(UdsRoutingContext);
};
